import { ICommandResult, Command } from '@/_core/cqrs/types/commands';

export class CreateWorkspace extends Command<ICreateWorkspaceResult> {
    constructor(public Subdomain: string, public Name: string, public Description: string) {
        super('CreateWorkspace');
    }
}

interface ICreateWorkspaceResult extends ICommandResult {
    Url: string;
}
